export default __webpack_public_path__ + "static/media/Assistance.5feb730e.png";